import React from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Box, Button } from '@mui/material';

type FileUploadProps = {
  handleAddFile: (e: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
  disabled?: boolean;
};

const FileUpload: React.FC<FileUploadProps> = ({ handleAddFile, disabled }) => {
  return (
    <Box>
      <Button
        component="label"
        title="Upload a file"
        variant="outlined"
        startIcon={<CloudUploadIcon />}
        color="primary"
        size="small"
        style={{ borderRadius: '30px' }}
        disabled={disabled}
      >
        Upload a File
        <input
          onChange={handleAddFile}
          type="file"
          hidden
          id="contained-button-file"
          name="upload-file"
        />
      </Button>
    </Box>
  );
};

export default FileUpload;
